var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsPortfolioManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -1842.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Portfolio-Management",
    transform: "translate(5026.000000, 1842.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0190437,9.54885838 C30.7021483,9.78785992 32,11.2188692 32,12.9668804 L32,12.9668804 L32,31.5 L8.47256012,31.5 C6.71640764,31.5 5.28046531,30.1919916 5.05031427,28.4999806 L5.05031427,28.4999806 L29.0190437,28.4999806 Z M7.67203477,0.5 L10.0065668,4.50002581 L23.5284405,4.50002581 C25.4436974,4.50002581 26.9967166,6.05203582 26.9967166,7.96704817 L26.9967166,7.96704817 L26.9967166,26.5001677 L3.46927671,26.5001677 C1.55301917,26.5001677 -9.23705556e-14,24.9481577 -9.23705556e-14,23.0331454 L-9.23705556e-14,23.0331454 L-9.23705556e-14,0.5 L7.67203477,0.5 Z M21.0137903,10.5000645 C19.3567028,10.5000645 18.0118203,11.8430732 18.0118203,13.5000839 L18.0118203,13.5000839 L18.0118203,22.5001419 C19.6689077,22.5001419 21.0137903,21.1561333 21.0137903,19.5001226 L21.0137903,19.5001226 Z M15.0098502,12.5000774 C13.3517621,12.5000774 12.0078802,13.8430861 12.0078802,15.5000968 L12.0078802,15.5000968 L12.0078802,22.5001419 C13.6659683,22.5001419 15.0098502,21.1561333 15.0098502,19.5001226 L15.0098502,19.5001226 Z M9.00591013,15.5000968 C7.34782201,15.5000968 6.00394009,16.8431054 6.00394009,18.5001161 L6.00394009,18.5001161 L6.00394009,22.5001419 C7.66202821,22.5001419 9.00591013,21.1561333 9.00591013,19.5001226 L9.00591013,19.5001226 Z",
    id: 13
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsPortfolioManagement);
export default __webpack_public_path__ + "static/media/investments-portfolio-management.0258d24b.svg";
export { ForwardRef as ReactComponent };